import { Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, Select, MenuItem, DialogActions, Button } from '@material-ui/core';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../../actions/ui/alertas';
import { enviarPDFSolicitudPago, imprimirSolicitudPago, previsualizarSolicitudPago } from '../../../actions/liquidaciones/liquidaciones';
import { LIQUIDACIONES_COMPROBANTES_ESTADOS } from '../../../utils/constants';

export const ComprobanteImpresionSolicitudPago = (props) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(null);
    const handleClose = () => {
        if (props.redirectHome)
            props.setMenu(0)

        else
            props.closeModalHandler();
    };


    const liquidada = props.comprobante?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA
    || props.comprobante?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA;

    const opciones = [
        { id: 1, display: `${liquidada ? "Imprimir" : "Previsualizar"} Solicitud Pago` },
        { id: 2, display: `${liquidada ? "Imprimir" : "Previsualizar"} Solicitud Pago Débitos` }
        //{ id: 3, display: `${liquidada ? "Imprimir" : "Previsualizar"} Solicitud Pago Débitos Cruzados` },
    ];


    if(liquidada)
        opciones.push({ id: 4, display: 'Enviar Solicitud Pago Débitos al Prestador' })

    const opcionesConst = {
        IMPRIMIR_SOLICITUD: 1,
        IMPRIMIR_SOLICITUD_PAGO: 2,
        //IMPRIMIR_SOLICITUD_PAGO_DEBITOS_CRUZADOS: 3,
        ENVIAR_SOLICITUD_PAGO_DEBITOS_PRESTADOR: 4,
    };


    // const urlBase = process.env.REACT_APP_URL

    const handleSubmit = (data) => {
        
        if (value === opcionesConst.IMPRIMIR_SOLICITUD) {
            if(liquidada)
              dispatch(imprimirSolicitudPago(value, props.solicitudPago?.idSolicitudPago))
            else
              dispatch(previsualizarSolicitudPago(props.comprobante?.idComprobante, value));
        } else if (value === opcionesConst.IMPRIMIR_SOLICITUD_PAGO) {
            if(liquidada) {
              dispatch(imprimirSolicitudPago(value, props.solicitudPago?.idSolicitudPago))
            }
            else
            dispatch(previsualizarSolicitudPago(props.comprobante?.idComprobante, value));
        } else if (value === opcionesConst.ENVIAR_SOLICITUD_PAGO_DEBITOS_PRESTADOR) {
            if (props.solicitudPago.nombreArchivoDebitos === "") {
                dispatch(startAlerta("No posee débitos.", "error"))
            }
            else {
                dispatch(enviarPDFSolicitudPago(props.solicitudPago?.idSolicitudPago, true, true));
            }
        }
    };

    console.log(props)

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={props.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Comprobante N° " + props.comprobante?.idComprobante}</DialogTitle>
                <DialogContent style={{ paddingTop: 10 }}>
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="impSolLabel">Opciones</InputLabel>
                                <Select
                                    labelId="impSolLabel"
                                    label="Opciones"
                                    name="opcionesSolicitud"
                                    value={value}
                                    onChange={(e) => setValue(e.target.value)}
                                >
                                    {opciones.map((t) => (
                                        <MenuItem key={t.id} value={t.id}>
                                            {t.display}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
